<script setup>
import "@/assets/main.css";

</script>
<template>
    <div class="flex h-fit justify-center bg-black py-3 pb-20">
        <div class="main-content flex flex-col justify-center text-center">
            <div class="text-off-white animated">
                <div
                    class="infoPengantin m-auto py-8 border border-putih-keabuan/80 px-12 bg-putih-keabuan/10 backdrop-blur-md">
                    <h3 class="font-dynalight text-2xl animated">
                        I Komang Agus Widyastana
                    </h3>
                    <div class="mt-3 text-sm text-putih-keabuan animated">
                        <p>Putra dari pasangan</p>
                        <p>
                            Bapak I Komang Artwa
                            <br />
                            & (Alm) Ibu Putu Suwartini
                        </p>
                    </div>
                    <p class="mt-1 text-sm text-off-white animated">Jl. Pulau Obi, Banyuning, Buleleng</p>
                    <!-- <br> -->
                    <h3 class="font-dynalight text-4xl my-5 animated">
                        &
                    </h3>
                    <!-- <br> -->
                    <h3 class="font-dynalight text-2xl animated">
                        Dewi Sondanggana
                    </h3>
                    <div class="mt-3 text-sm text-putih-keabuan animated">
                        <p>Putri dari pasangan</p>
                        <p>
                            Bapak l Made Dwiasan
                            <br />
                            & Ibu Margareta Seran Klau
                        </p>
                    </div>
                    <p class="mt-1 text-sm text-off-white animated">Br. Tohpati, Ds. Bongkasa, Abiansemal</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style></style>
